﻿import { FunctionComponent } from "react";
import { ApiContextProvider, ApiContextProviderProps } from "../ApiContext";
import { EnvironmentContextProvider, EnvironmentContextProviderProps } from "../EnvironmentContext";
import { AuthenticationContextProvider, AuthenticationContextProviderProps } from "../AuthenticationContext";
import { OIDAwareAppInsightsContextProvider, OIDAwareAppInsightsContextProviderProps } from "../AppInsightsContextProvider";

type AppConfigurationProviderProps = ApiContextProviderProps &
    AuthenticationContextProviderProps &
    EnvironmentContextProviderProps &
    OIDAwareAppInsightsContextProviderProps;
export const AppConfigurationProvider: FunctionComponent<AppConfigurationProviderProps> = ({
    envJsonUrl,
    onApiContextInit,
    appInsightsConfig,
    version,
    onAppInsightsInit,
    children,
}) => {
    return (
        <EnvironmentContextProvider envJsonUrl={envJsonUrl}>
            <AuthenticationContextProvider>
                <ApiContextProvider onApiContextInit={onApiContextInit}>
                    <OIDAwareAppInsightsContextProvider appInsightsConfig={appInsightsConfig} version={version} onAppInsightsInit={onAppInsightsInit}>
                        {children}
                    </OIDAwareAppInsightsContextProvider>
                </ApiContextProvider>
            </AuthenticationContextProvider>
        </EnvironmentContextProvider>
    );
};
